import { c as _c } from "react/compiler-runtime";
import CommonWidgetContext from '@shared/utils/context/CommonWidgetContext';
import dynamic from 'next/dynamic';
import { useContext } from 'react';

// Confetti only ever fires after a celebration event, but the static import put
// react-confetti in the root Provider chunk for every pageview.
const Confetti = dynamic(() => import('react-confetti'), {
  ssr: false
});
const CommonWidgets = () => {
  const $ = _c(4);
  const {
    confettiRunning
  } = useContext(CommonWidgetContext);
  let t0;
  if ($[0] !== confettiRunning) {
    t0 = confettiRunning && <Confetti recycle={false} />;
    $[0] = confettiRunning;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <>{t0}</>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default CommonWidgets;